/**
 * The one href mapper for linked entities (GRW-10, 20-growth.md §3.2). It mirrors
 * zou's `entityHref` (services/zou/pkg/connecthandlers/pursuit_read.go) kind for
 * kind, so a chip built in the browser and a link built by the server agree.
 */ import { proposalHref } from '../../../lib/proposalHref';
import { registryHref } from '../../Registries/registryHref';
/**
 * MUST equal `registryRecordRoutesLive` in services/zou/pkg/connecthandlers/pursuit_read.go.
 * Flip both together; until then registry links use the /registries?tab= fallback.
 */ export const registryRecordRoutesLive = false;
const enc = encodeURIComponent;
// kind -> [registryHref kind, fallback tab]
const REGISTRY_KINDS = {
    person: [
        'CONTACT',
        'contacts'
    ],
    company: [
        'COMPANY',
        'companies'
    ],
    government_org: [
        'GOVERNMENT_ORG',
        'govorgs'
    ],
    vehicle: [
        'VEHICLE',
        'vehicles'
    ]
};
// kinds whose route registryHref already owns and agrees with zou on
const SHARED_KINDS = {
    pursuit: 'PURSUIT',
    program: 'PROGRAM',
    rfi_response: 'RFI_RESPONSE',
    landscape: 'LANDSCAPE'
};
/** Returns null for an empty id, an unknown kind, or a kind missing its extra. */ export function entityHref(kind, id, extra = {}) {
    if (!id) return null;
    const shared = SHARED_KINDS[kind];
    if (shared) return registryHref({
        kind: shared,
        id
    });
    const registry = REGISTRY_KINDS[kind];
    if (registry) {
        return registryRecordRoutesLive ? registryHref({
            kind: registry[0],
            id
        }) : `/registries?tab=${registry[1]}&record=${enc(id)}`;
    }
    switch(kind){
        case 'opportunity':
            return extra.notice_id ? `/opportunities?notice=${enc(extra.notice_id)}` : null;
        case 'notice':
            return `/opportunities?notice=${enc(id)}`;
        case 'proposal':
            return proposalHref(id, 'home');
        case 'library_item':
            return `/library?item=${enc(id)}`;
        case 'seat':
            return extra.landscape_id ? `/landscapes/${enc(extra.landscape_id)}/seats?seat=${enc(id)}` : null;
        default:
            return null;
    }
}
